'use client';

import { Button } from '@/features/uiKit/Button';
import { Stack } from '@/features/uiKit/Stack';
import { useEffect, useState } from 'react';
import { getAppUrlStart } from '../Lang/getUrlStart';
interface FirstEnterButtonProps {
  getStartedTitle: string;
  practiceLink: string;
  openMyPracticeLinkTitle: string;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
}

export const FirstEnterButton: React.FC<FirstEnterButtonProps> = ({
  getStartedTitle,
  practiceLink,
  openMyPracticeLinkTitle,
  endIcon,
  startIcon,
}) => {
  const [isSignInToLanguage, setIsSignInToLanguage] = useState('');
  const openMyPracticeLink = isSignInToLanguage
    ? getAppUrlStart(isSignInToLanguage) + 'practice'
    : '';

  useEffect(() => {
    const isWindow = typeof window !== 'undefined';
    if (!isWindow) return;
    const storedLanguage = localStorage.getItem('pageLanguageCode');
    if (storedLanguage) {
      setTimeout(() => {
        setIsSignInToLanguage(storedLanguage);
      }, 20);
    }
  }, []);

  return (
    <Stack
      sx={{
        alignItems: 'center',
        gap: '5px',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Button
        size="large"
        href={openMyPracticeLink || practiceLink}
        data-analytics={openMyPracticeLink ? 'returning-practice' : 'hero-cta'}
        endIcon={endIcon}
        startIcon={startIcon}
      >
        {openMyPracticeLink ? openMyPracticeLinkTitle : getStartedTitle}
      </Button>
    </Stack>
  );
};

export const WelcomeScreenButton: React.FC<FirstEnterButtonProps> = ({
  getStartedTitle,
  practiceLink,
  openMyPracticeLinkTitle,
}) => {
  const [isSignInToLanguage, setIsSignInToLanguage] = useState('');
  const openMyPracticeLink = isSignInToLanguage
    ? getAppUrlStart(isSignInToLanguage) + 'practice'
    : '';

  useEffect(() => {
    const isWindow = typeof window !== 'undefined';
    if (!isWindow) return;
    const storedLanguage = localStorage.getItem('pageLanguageCode');
    if (storedLanguage) {
      setTimeout(() => {
        setIsSignInToLanguage(storedLanguage);
      }, 20);
    }
  }, []);

  const label = openMyPracticeLink ? openMyPracticeLinkTitle : getStartedTitle;

  return (
    <Stack
      sx={{
        alignItems: 'center',
        gap: '5px',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Button
        size="hero"
        href={openMyPracticeLink || practiceLink}
        data-analytics={openMyPracticeLink ? 'returning-practice' : 'hero-cta'}
      >
        {label}
      </Button>
    </Stack>
  );
};
